module.exports = __webpack_public_path__ + "media/images/heart-5090e0ab999e752017e5a05f92cd7c5f.svg";